module.exports = __webpack_public_path__ + "img/about-family.jpg?486cfe12cd435a6ca82a6fe8426c824c";